module.exports = __webpack_public_path__ + "img/1495595319.e92ca6a3.jpg";